<template>
  <div id="left-sidebar" class="sidebar">
    <div class="">
      <div class="navbar-brand">
        <router-link
          class="main-logo"
          to="/transaction/middleware"
          v-if="toggleSidebarTheme == ''"
        >
          <img
            src="@/assets/payangel_logo.png"
            alt="PayAngel Logo"
            class="img-responsive logo"
          />
        </router-link>
        <router-link
          class="main-logo-icon"
          to="/transaction/middleware"
          v-if="toggleSidebarTheme == ''"
        >
          <img
            src="@/assets/logo-icon.svg"
            alt="PayAngel Logo"
            class="img-responsive logo img-fluid"
          />
        </router-link>

        <router-link
          class="main-logo"
          to="/transaction/middleware"
          v-if="toggleSidebarTheme == 'full-dark' && isSidebarSmall == false"
        >
          <img
            src="@/assets/payangel_logo_w.png"
            alt="PayAngel Logo"
            class="img-responsive logo"
          />
        </router-link>
        <router-link
          class="main-logo-icon"
          to="/transaction/middleware"
          v-if="toggleSidebarTheme == 'full-dark' && isSidebarSmall == true"
        >
          <img
            src="@/assets/logo-icon-w.svg"
            alt="PayAngel Logo"
            class="img-responsive logo img-fluid"
          />
        </router-link>

        <button
          type="button"
          class="btn-toggle-offcanvas btn btn-sm btn-default"
          v-on:click="backSideMenu()"
        >
          <i class="lnr lnr-menu fa fa-chevron-circle-left"></i>
        </button>
      </div>
      <div class="user-account">
        <div class="user_div">
          <img
            :src="require('@/assets/xs/male-placeholder.webp')"
            class="rounded-circle user-photo"
            alt="User Profile Picture"
          />
        </div>
        <div
          class="dropdown"
          v-bind:class="{ show: dropActive }"
          @click="dropActive = !dropActive"
          v-click-outside="outside"
        >
          <a
            href="javascript:void(0);"
            class="dropdown-toggle user-name"
            data-toggle="dropdown"
            :aria-expanded="dropActive ? 'true' : 'false'"
          >
            <strong>
              {{ currentuser?.firstname }} {{ currentuser?.lastname }}
            </strong>
          </a>
          <ul
            class="dropdown-menu dropdown-menu-right account"
            v-bind:class="{ show: dropActive }"
            :style="
              dropActive
                ? 'top: 100%; position: absolute; transform: translate3d(-52px, 42px, 0px); left: 0px; will-change: transform;'
                : 'top: 80%; position: absolute; transform: translate3d(-52px, 42px, 0px); left: 0px; will-change: transform;'
            "
          >
            <!-- <li><router-link to="/setting/profile"><i class="icon-user"></i>My Profile</router-link></li> -->
            <!-- <li><router-link to="/app/app-inbox"><i class="icon-envelope-open"></i>Messages</router-link></li>
                    <li><a href="javascript:void(0);"><i class="icon-settings"></i>Settings</a></li>
                    <li class="divider"></li> -->
            <li>
              <router-link to="/onboarding/submissions">
                <i class="fa fa-clipboard"></i>
                Onboarding Review
              </router-link>
            </li>
            <li class="divider"></li>
            <li>
              <router-link to="/page-login">
                <i class="icon-power"></i>
                Logout
              </router-link>
            </li>
          </ul>
        </div>
        <span>Admin</span>
      </div>
      <!-- Nav tabs -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link"
            v-on:click="setActiveNavtab('Menu')"
            :class="{ 'active show': openNavtab('Menu') }"
            data-toggle="tab"
          >
            Menu
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-on:click="setActiveNavtab('Setting')"
            :class="{ 'active show': openNavtab('Setting') }"
            data-toggle="tab"
          >
            <i class="icon-settings"></i>
          </a>
        </li>
      </ul>
      <!-- Tab panes -->
      <div class="tab-content p-l-0 p-r-0">
        <div
          class="tab-pane"
          :class="{ 'active show': openNavtab('Menu') }"
          id="menu"
        >
          <nav id="left-sidebar-nav" class="sidebar-nav">
            <ul id="main-menu" class="metismenu">
              <li 
              v-if="isMenuItemEnabled('dashboard') || hasPermission('dashboard.view')"
              v-bind:class="{ 'active': currentActiveMenu == 'dashboard' }">
                <router-link to="/dashboard" title="Dashboard"><i class="icon-home mr-1"></i><span>Dashboard</span></router-link>
              </li>
              <li 
                v-if="isMenuItemEnabled('bin') || hasAnyPermission(['bin.view', 'bin.create', 'bin.download', 'bin.edit', 'bin.delete'])"
                v-bind:class="{ active: currentActiveMenu == 'bin' }">
                <router-link to="/bin/list" title="Bin">
                  <i class="fa fa-credit-card-alt mr-1"></i>
                  <span> Bin</span>
                </router-link>
              </li>
              <li
                v-if="isMenuItemEnabled('business') || hasAnyPermission(['business.view', 'business.status','business.delete'])"
                v-bind:class="{ active: currentActiveMenu == 'business' }">
                <router-link to="/business/list" title="Business">
                  <i class="icon-briefcase mr-1"></i>
                  <span>Business</span>
                </router-link>
              </li>
              <li
                :class="{ active: currentActiveMenu === 'onboarding' }"
                @mouseover="isHover('onboarding', true)"
                @mouseleave="isHover('onboarding', false)"
              >
                <a class="has-arrow" v-on:click="setActive('onboarding')">
                  <i class="fa fa-clipboard mr-1"></i>
                  <span>Onboarding</span>
                </a>
                <ul
                  v-if="!isHoverOnboarding && !isSidebarSmall"
                  v-bind:class="
                    currentActiveMenu == 'onboarding'
                      ? 'collapse in'
                      : 'collapse'
                  "
                >
                  <li
                    v-bind:class="{
                      active: currentRoutePath == '/onboarding/submissions',
                    }"
                  >
                    <router-link to="/onboarding/submissions">Submissions Queue</router-link>
                  </li>
                  <li
                    v-bind:class="{
                      active: currentRoutePath == '/onboarding/assigned',
                    }"
                  >
                    <router-link to="/onboarding/assigned">Assigned to Me</router-link>
                  </li>
                  <li
                    v-bind:class="{
                      active: currentRoutePath == '/onboarding/document-requirements',
                    }"
                  >
                    <router-link to="/onboarding/document-requirements">Document Requirements</router-link>
                  </li>
                  <li
                    v-bind:class="{
                      active: currentRoutePath == '/onboarding/document-types',
                    }"
                  >
                    <router-link to="/onboarding/document-types">Document Types</router-link>
                  </li>
                </ul>
                <template v-else>
                  <ul
                    :class="
                      isHoverOnboarding && isSidebarSmall ? 'collapse in' : 'collapse'
                    "
                  >
                    <li
                      v-bind:class="{
                        active: currentRoutePath == '/onboarding/submissions',
                      }"
                    >
                      <router-link to="/onboarding/submissions">Submissions Queue</router-link>
                    </li>
                    <li
                      v-bind:class="{
                        active: currentRoutePath == '/onboarding/assigned',
                      }"
                    >
                      <router-link to="/onboarding/assigned">Assigned to Me</router-link>
                    </li>
                    <li
                      v-bind:class="{
                        active: currentRoutePath == '/onboarding/document-requirements',
                      }"
                    >
                      <router-link to="/onboarding/document-requirements">Document Requirements</router-link>
                    </li>
                    <li
                      v-bind:class="{
                        active: currentRoutePath == '/onboarding/document-types',
                      }"
                    >
                      <router-link to="/onboarding/document-types">Document Types</router-link>
                    </li>
                  </ul>
                </template>
              </li>
              <li
                v-if="hasAnyPermission(['country.view', 'country.edit','country.details','country.status'])"
                :class="{
                  active:
                    currentActiveMenu === 'country' ||
                    currentActiveMenu === 'list',
                }"
                @mouseover="isHover('list', true)"
                @mouseleave="isHover('list', false)"
              >
                <a class="has-arrow" v-on:click="setActive('country')">
                  <i class="fa fa-list mr-1"></i>
                  <span>Listing</span>
                </a>
                <ul
                  v-if="!isListing && !isSidebarSmall"
                  v-bind:class="
                    currentActiveMenu == 'country' ||
                    currentActiveMenu == 'list'
                      ? 'collapse in'
                      : 'collapse'
                  "
                >
                  <li
                    v-bind:class="{
                      active:
                        currentRoutePath == '/country/list' ||
                        currentRoutePath == '/country/details',
                    }"
                    v-if="isMenuItemEnabled('country') || hasAnyPermission(['country.view', 'country.edit','country.details','country.status'])"
                  >
                    <router-link to="/country/list">Country List</router-link>
                  </li>
                </ul>
                <template v-else>
                  <ul
                    :class="
                      isListing && isSidebarSmall ? 'collapse in' : 'collapse'
                    "
                  >
                    <li
                      v-if="isMenuItemEnabled('country') || hasAnyPermission(['country.view', 'country.edit','country.details','country.status'])"
                      v-bind:class="{
                        active:
                          currentRoutePath == '/country/list' ||
                          currentRoutePath == '/country/details',
                      }"
                    >
                      <router-link to="/country/list">Country List</router-link>
                    </li>
                  </ul>
                </template>
              </li>


              <li
                v-if="hasAnyPermission(['analytics.view','dailytransaction.view'])"
                :class="{ active: currentActiveMenu === 'analytics' }"
                @mouseover="isHover('analytics', true)"
                @mouseleave="isHover('analytics', false)"
              >
                <a class="has-arrow" v-on:click="setActive('analytics')">
                  <i class="fa fa-bars mr-1"></i>
                  <span>Report & Analytics</span>
                </a>
                <ul
                  v-if="!isReportAnalytics && !isSidebarSmall"
                  v-bind:class="
                    currentActiveMenu == 'analytics'
                      ? 'collapse in'
                      : 'collapse'
                  "
                >
                  <li
                    v-if="isMenuItemEnabled('analytics') || hasAnyPermission(['analytics.view'])"
                    v-bind:class="{
                      active: currentRoutePath == '/analytics',
                    }"
                  >
                    <router-link to="/analytics">
                      Analytics
                    </router-link>
                  </li>
                  <li
                    v-if="isMenuItemEnabled('dailytransaction') || hasAnyPermission(['dailytransaction.view'])"
                    v-bind:class="{
                      active: currentRoutePath == '/daily-transaction-tracker',
                    }"
                  >
                    <router-link to="/daily-transaction-tracker">
                      Daily Transaction
                    </router-link>
                  </li>
                </ul>
                <template v-else>
                  <ul
                    :class="
                      isReportAnalytics && isSidebarSmall
                        ? 'collapse in'
                        : 'collapse'
                    "
                  >
                    <li
                      v-if="isMenuItemEnabled('analytics') || hasAnyPermission(['analytics.view'])"
                      v-bind:class="{
                        active: currentRoutePath == '/analytics',
                      }"
                    >
                      <router-link to="/analytics">
                        Analytics
                      </router-link>
                    </li>
                    <li
                      v-if="isMenuItemEnabled('dailytransaction') || hasAnyPermission(['dailytransaction.view'])"
                      v-bind:class="{
                        active: currentRoutePath == '/daily-transaction-tracker',
                      }"
                    >
                      <router-link to="/daily-transaction-tracker">
                        Daily Transaction
                      </router-link>
                    </li>
                  </ul>
                </template>
              </li>


              <li
                v-if="hasAnyPermission(['transaction.view','transaction.status','transaction.process','transaction.bulk'])"
                :class="{ active: currentActiveMenu === 'transaction' }"
                @mouseover="isHover('transaction', true)"
                @mouseleave="isHover('transaction', false)"
              >
                <a class="has-arrow" v-on:click="setActive('transaction')">
                  <i class="fa fa-bars mr-1"></i>
                  <span>Risk & Transaction</span>
                </a>
                <ul
                  v-if="!isTransactionlist && !isSidebarSmall"
                  v-bind:class="
                    currentActiveMenu == 'transaction'
                      ? 'collapse in'
                      : 'collapse'
                  "
                >
                  <li
                    v-if="isMenuItemEnabled('transaction') || hasAnyPermission(['transaction.view','transaction.status','transaction.process','transaction.bulk'])"
                    v-bind:class="{
                      active: currentRoutePath == '/transaction/middleware',
                    }"
                  >
                    <router-link to="/transaction/middleware">
                      Transaction List
                    </router-link>
                  </li>
                </ul>
                <template v-else>
                  <ul
                    :class="
                      isTransactionlist && isSidebarSmall
                        ? 'collapse in'
                        : 'collapse'
                    "
                  >
                    <li
                      v-if="isMenuItemEnabled('transaction') || hasAnyPermission(['transaction.view','transaction.status','transaction.process','transaction.bulk'])"
                      v-bind:class="{
                        active: currentRoutePath == '/transaction/middleware',
                      }"
                    >
                      <router-link to="/transaction/middleware">
                        Transaction List
                      </router-link>
                    </li>
                  </ul>
                </template>
              </li>
              <li 
                v-if="isMenuItemEnabled('fxrates') || hasAnyPermission(['fxrates.view','fxrates.edit','fxrates.status','fxrates.update','fxrates.csvupload'])"
                v-bind:class="{ active: currentActiveMenu == 'fx-rates' }">
                <router-link to="/fx-rates" title="FX Rates Management">
                  <i class="fa fa-money mr-1"></i>
                  <span>FX Rates</span>
                </router-link>
              </li>
              <li
                v-if="hasAnyPermission(['remitter.view','receiver.view','bank.view','momo.view','remitter.status','remitter.enable','remitter.lock','remitter.edit','remitter.login','remitter.reset','remitter.delete','receiver.status','receiver.details','bank.status','momo.status'])"
                :class="{
                  active:
                    currentActiveMenu === 'customer' ||
                    (currentActiveMenu === 'beneficiary' &&
                      currentRoutePath == '/beneficiary/all'),
                }"
                @mouseover="isHover('customer', true)"
                @mouseleave="isHover('customer', false)"
              >
                <a class="has-arrow" v-on:click="setActive('customer')">
                  <i class="fa fa-users mr-1"></i>
                  <span>Members</span>
                </a>
                <ul
                  v-if="!isCustomerlist && !isSidebarSmall"
                  v-bind:class="
                    currentActiveMenu == 'customer' || currentActiveMenu == 'accounts' ||
                    (currentActiveMenu === 'beneficiary' &&
                      currentRoutePath == '/beneficiary/all')
                      ? 'collapse in'
                      : 'collapse'
                  "
                >
                  <li
                    v-if="isMenuItemEnabled('customer') || hasAnyPermission(['remitter.view','remitter.status','remitter.enable','remitter.lock','remitter.edit','remitter.login','remitter.reset','remitter.delete'])"
                    v-bind:class="{
                      active: currentRoutePath == '/customer/list',
                    }"
                  >
                    <router-link to="/customer/list">Remitters</router-link>
                  </li>
                  <li
                    v-if="isMenuItemEnabled('beneficiary') || hasAnyPermission(['receiver.view','receiver.status','receiver.details'])"
                    v-bind:class="{
                      active: currentRoutePath == '/beneficiary/all',
                    }"
                  >
                    <router-link to="/beneficiary/all">Receivers</router-link>
                  </li>
                  <li
                    v-if="isMenuItemEnabled('accounts') || hasAnyPermission(['bank.view','momo.view','bank.status','momo.status'])"
                    v-bind:class="{
                      active: currentRoutePath == '/accounts/list',
                    }"
                  >
                    <router-link to="/accounts/list">Accounts</router-link>
                  </li>
                </ul>
                <template v-else>
                  <ul
                    :class="
                      isCustomerlist && isSidebarSmall
                        ? 'collapse in'
                        : 'collapse'
                    "
                  >
                    <li
                      v-if="isMenuItemEnabled('customer') || hasAnyPermission(['remitter.view','remitter.status','remitter.enable','remitter.lock','remitter.edit','remitter.login','remitter.reset','remitter.delete'])"
                      v-bind:class="{
                        active: currentRoutePath == '/customer/list',
                      }"
                    >
                      <router-link to="/customer/list">Remitters</router-link>
                    </li>
                    <li
                      v-if="isMenuItemEnabled('beneficiary') || hasAnyPermission(['receiver.view','receiver.status','receiver.details'])"
                      v-bind:class="{
                        active: currentRoutePath == '/beneficiary/all',
                      }"
                    >
                      <router-link to="/beneficiary/all">Receivers</router-link>
                    </li>
                    <li
                      v-if="isMenuItemEnabled('accounts') || hasAnyPermission(['bank.view','momo.view','bank.status','momo.status'])"
                      v-bind:class="{
                        active: currentRoutePath == '/customer/accounts',
                      }"
                    >
                      <router-link to="/customer/accounts">
                        Accounts
                      </router-link>
                    </li>
                  </ul>
                </template>
              </li>

              <li
                v-if="hasAnyPermission(['settings.view','settings.edit'])"
                :class="{
                  active:
                    currentActiveMenu === 'setting' 
                }"
                @mouseover="isHover('setting', true)"
                @mouseleave="isHover('setting', false)"
              >
                <a class="has-arrow" v-on:click="setActive('setting')">
                  <i class="fa fa-cog mr-1"></i>
                  <span>Settings</span>
                </a>
                <ul
                  v-if="!isListing && !isSidebarSmall"
                  v-bind:class="
                    currentActiveMenu === 'setting'
                      ? 'collapse in'
                      : 'collapse'
                  "
                >
                  <li
                    v-if="isMenuItemEnabled('setting') || hasAnyPermission(['settings.view','settings.edit'])"
                    v-bind:class="{
                      active: currentRoutePath == '/setting/settings',
                    }"
                  >
                    <router-link to="/setting/settings">
                      Global Settings
                    </router-link>
                  </li>
                </ul>
                <template v-else>
                  <ul
                    :class="
                      isHoverSetting && isSidebarSmall ? 'collapse in' : 'collapse'
                    "
                  >
                    <li
                      v-if="isMenuItemEnabled('setting') || hasAnyPermission(['settings.view','settings.edit'])"
                      v-bind:class="{
                        active: currentRoutePath == '/setting/settings',
                      }"
                    >
                      <router-link to="/setting/settings">
                        Global Settings
                      </router-link>
                    </li>
                  </ul>
                </template>
              </li>

              <li
                v-if="isMenuItemEnabled('internal-users') || hasAnyPermission(['users.view','users.create','users.edit','users.delete','users.status'])"
                v-bind:class="{ active: currentActiveMenu == 'internal-users' }"
              >
                <router-link to="/internal-users/list" title="User Management">
                  <i class="fa fa-user-secret mr-1"></i>
                  <span>User Management</span>
                </router-link>
              </li>

              <li
                v-if="isMenuItemEnabled('internal-user-roles') || hasAnyPermission(['roles.view','roles.create','roles.edit','roles.delete','roles.status'])"
                v-bind:class="{
                  active: currentActiveMenu == 'internal-user-roles',
                }"
              >
                <router-link
                  to="/internal-user-roles/list"
                  title="User Role Management"
                >
                  <i class="fa fa-lock mr-1"></i>
                  <span>User Role Management</span>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
        <div
          class="tab-pane p-l-15 p-r-15"
          :class="{ 'active show': openNavtab('Setting') }"
          id="setting"
        >
          <h6>Choose Mode</h6>
          <ul class="choose-skin list-unstyled">
            <li
              data-theme="white"
              :class="{ active: data_theme === '' }"
              v-on:click="setactiveTheme('')"
            >
              <div class="white"></div>
              <span>Light</span>
            </li>
            <li
              data-theme="black"
              :class="{ active: data_theme === 'full-dark' }"
              v-on:click="setactiveTheme('full-dark')"
            >
              <div class="black"></div>
              <span>Dark</span>
            </li>
          </ul>
          <hr />
          <h6>Choose Skin</h6>
          <ul class="choose-skin list-unstyled">
            <li
              data-theme="radical-red"
              v-bind:class="{ active: activeColor === 'radical-red' }"
              v-on:click="changeBodycolor('radical-red')"
            >
              <div class="radical-red"></div>
              <span>Radical Red</span>
            </li>
            <li
              data-theme="turquoise"
              v-bind:class="{ active: activeColor === 'turquoise' }"
              v-on:click="changeBodycolor('turquoise')"
            >
              <div class="turquoise"></div>
              <span>Turquoise</span>
            </li>
            <li
              data-theme="midnight-express"
              v-bind:class="{ active: activeColor === 'midnight-express' }"
              v-on:click="changeBodycolor('midnight-express')"
            >
              <div class="midnight-express"></div>
              <span>Midnight Express</span>
            </li>
            <li
              data-theme="morning-glory"
              v-bind:class="{ active: activeColor === 'morning-glory' }"
              v-on:click="changeBodycolor('morning-glory')"
            >
              <div class="morning-glory"></div>
              <span>Morning Glory</span>
            </li>
            <li
              data-theme="dark-cyan"
              v-bind:class="{ active: activeColor === 'dark-cyan' }"
              v-on:click="changeBodycolor('dark-cyan')"
            >
              <div class="dark-cyan"></div>
              <span>Dark Cyan</span>
            </li>
            <li
              data-theme="purple"
              v-bind:class="{ active: activeColor === 'purple' }"
              v-on:click="changeBodycolor('purple')"
            >
              <div class="purple"></div>
              <span>Purple</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Loader -->
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/plugins/event-bus.js";
// import { GET_MENU_LIST } from "../../../../store/actions.type.js";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;

export default {
  name: "SidebarComponent",
  components: {
    "main-loader": LoaderComponent,
  },
  methods: {
    changeBodycolor(color) {
      this.activeColor = color;
      document.body.className = "theme-" + color + " " + this.data_theme;
    },

    outside: function () {
      this.dropActive = false;
    },

    setActive: function (menuItem) {
      console.log("setactive", this.currentActiveMenu, menuItem);
      if (this.currentActiveMenu === menuItem) {
        this.currentActiveMenu = null;
      } else {
        this.currentActiveMenu = menuItem;
      }
    },

    openNavtab: function (tab) {
      return this.currentMenuTab === tab;
    },
    setActiveNavtab: function (tab) {
      this.currentMenuTab = tab;
    },
    setactiveTheme: function (theme) {
      this.data_theme = theme;
      document.body.className = "theme-" + this.activeColor + " " + theme;
      EventBus.$emit("theme", theme);
    },
    backSideMenu: function () {
      document.body.classList.toggle("offcanvas-active");
    },
    isHover(module, hover) {
      if (document.body.classList.contains("layout-fullwidth")) {
        if (module == "list") {
          this.isListing = hover;
        }
        if (module == "transaction") {
          this.isTransactionlist = hover;
        }
        if( module == "analytics") {
          this.isReportAnalytics = hover;
        }
        if (module == "setting") {
          this.isHoverSetting = hover;
        }
        if (module == "customer") {
          this.isCustomerlist = hover;
        }
        if (module == "partner") {
          this.isHoverPartner = hover;
        }
        if (module == "user-managment") {
          this.isHoverUserManagement = hover;
        }
        if (module == "remitter-credit") {
          this.isHoverRemitterCredit = hover;
        }
        if (module == "reports") {
          this.isHoverReports = hover;
        }
        if (module == "send-promotional-email") {
          this.isHoverSendemail = hover;
        }
        if (module == "remitter-group-management") {
          this.isHoverRemitterGroupManagement = hover;
        }
        if (module == "coupon-managment") {
          this.isHovercouponManagement = hover;
        }
        if (module == "onboarding") {
          this.isHoverOnboarding = hover;
        }
        if (module == "cms") {
          this.isHoverContent = hover;
        }
      }
    },

    // async menuDetail() {
    //   this.isLoading = true;
    //   // Removed this.setLoading(true); as it does not exist

    //   try {
    //     this.menu_list = [];
    //     let allowedPaths = [];
    //     await this.$store.dispatch(GET_MENU_LIST).then((response) => {
    //       if (response.data.code == "0014-100") {
    //         response.data.menus.map((item) => {
    //           this.menu_list.push(item);
    //           allowedPaths.push(item.path);
    //           if (item.children && item.children.length > 0) {
    //             item.children.forEach((child) => allowedPaths.push(child.path));
    //           }
    //         });
    //         // Add static "Dashboard" menu JSON
    //         const dashboardMenu = {
    //           name: "Dashboard",
    //           path: "/dashboard",
    //           icon: "fa fa-home",
    //           children: [],
    //         };

    //         // Insert at the top of the menu list
    //         this.menu_list.unshift(dashboardMenu);

    //         // Also include its path in allowed paths
    //         allowedPaths.push(dashboardMenu.path);

    //         // Remove duplicates just in case
    //         allowedPaths = [...new Set(allowedPaths)];

    //         // Store allowed menu paths in localStorage for permission check
    //         localStorage.setItem("userMenuList", JSON.stringify(allowedPaths));
    //       }
    //     });
    //   } catch (error) {
    //     console.error("Error fetching users:", error);
    //     this.$toast.error(
    //       error.response?.data?.message ||
    //         "Failed to fetch users. Please try again.",
    //       { position: "top-right" },
    //     );
    //     this.menu_list = [];
    //   } finally {
    //     this.isLoading = false;
    //     // Removed this.setLoading(false); as it does not exist
    //   }
    // },

    isMenuItemEnabled(itemKey) {
      // Use Vuex store to check if menu is allowed
      return this.$store.getters["authpermission/isMenuAllowed"](itemKey);
    },

    // Check if user has a specific permission
    hasPermission(permission) {
      return this.$store.getters["authpermission/hasPermission"](permission);
    },

    // Check if user has any of the provided permissions
    hasAnyPermission(permissions) {
      return this.$store.getters["authpermission/hasAnyPermission"](permissions);
    },

    loadNavigationPermissions() {
      // Navigation permissions are now loaded from Vuex store
      // This method kept for backward compatibility but data comes from store
      const allowedMenuItems = this.$store.getters["authpermission/isMenuAllowed"];
      this.enabledMenuItems = allowedMenuItems;
    },

    loadUserRole() {
      try {
        const jwtToken = localStorage.getItem("jwtToken");
        if (!jwtToken) {
          return;
        }
        const jwtParts = jwtToken.split(".");
        const jwtBodyBase64 = jwtParts[1];
        const jwtBodyJson = atob(jwtBodyBase64);
        const jwtBody = JSON.parse(jwtBodyJson);
        this.userRole = jwtBody?.extra?.role || null;
      } catch (err) {
        console.error("Failed to parse access token: ", err);
        this.userRole = null;
      }
    },
  },
  data() {
    return {
      isListing: false,
      isTransactionlist: false,
      isHoverSetting: false,
      isSidebarSmall: false,
      isCustomerlist: false,
      isHoverPartner: false,
      isHoverRemitterCredit: false,
      isHoverReports: false,
      isHoverSendemail: false,
      isHoverRemitterGroupManagement: false,
      isHoverUserManagement: false,
      isHovercouponManagement: false,
      isHoverContent: false,
      isHoverOnboarding: false,
      isReportAnalytics: false,
      currentActiveMenu: (this.$route && this.$route.matched && this.$route.matched.length > 0 && this.$route.matched[0].path
        ? this.$route.matched[0].path.replace(/\//, "")
        : (window.location.pathname.split("/")[1] || "")),
      //currentActiveMenu: window.location.pathname.split("/")[1],
      currentMenuTab: "Menu",
      activeColor: "turquoise",
      dropActive: "",
      data_theme: "",
      toggleSidebarClass: false,
      toggleSidebarTheme: "",

      menu_list: [],
      isLoading: false, // Add isLoading to fix Vue warn
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },
    },
  },
  computed: {
    ...mapGetters(["currentuser"]),
    currentRoutePath() {
      return this.$route.path;
    },

    activeMenu() {
      if (this.$route && this.$route.matched && this.$route.matched.length > 0 && this.$route.matched[0].path) {
        let menuList1 = this.$route.matched[0].path.split("/");
        let index1 = menuList1.indexOf("admin");
        if (index1 > -1) {
          menuList1.splice(index1, 1);
        }
        let matchedMenu1 = menuList1.filter((item) => item);
        return matchedMenu1[0];
      } else {
        // fallback to path from window.location
        let menuList2 = window.location.pathname.split("/");
        let index2 = menuList2.indexOf("admin");
        if (index2 > -1) {
          menuList2.splice(index2, 1);
        }
        let matchedMenu2 = menuList2.filter((item) => item);
        return matchedMenu2[0] || "";
      }
    },

     // Get user permissions from Vuex store
    userPermissions() {
      return this.$store.getters["authpermission/allPermissions"];
    },

    // Get user roles from Vuex store
    userRoles() {
      return this.$store.getters["authpermission/allRoles"];
    },

    // Track permissions for reactivity
    permissionsKey() {
      // This computed property will change whenever permissions change
      // causing Vue to re-render components that depend on it
      return JSON.stringify(this.$store.state.auth.permissions || []);
    },

    // Track allowed menu items for reactivity
    allowedMenuItemsKey() {
      return JSON.stringify(this.$store.state.auth.allowedMenuItems || []);
    },
  },
  watch: {
    $route() {
      this.currentActiveMenu = this.activeMenu.replace(/\//, "");
      document.body.className =
        "theme-" + this.activeColor + " " + this.data_theme;
      if (localStorage.getItem("sidebarmini") == "true") {
        document.body.classList.add("layout-fullwidth");
      }
    },

    // Watch for permission changes and force menu re-render
    permissionsKey(newVal, oldVal) {
      if (newVal !== oldVal) {
        console.log("🔄 Permissions changed, updating sidebar menu");
        this.$forceUpdate(); // Force re-render of sidebar
      }
    },

    // Watch for menu item changes
    allowedMenuItemsKey(newVal, oldVal) {
      if (newVal !== oldVal) {
        console.log("🔄 Allowed menu items changed, updating sidebar");
        this.$forceUpdate(); // Force re-render of sidebar
      }
    },
  },
  mounted() {
    if (localStorage.getItem("sidebarmini") == "true") {
      document.body.classList.add("layout-fullwidth");
      this.isSidebarSmall = true;
    }
    EventBus.$on("theme", (theme) => {
      this.toggleSidebarTheme = theme;
    });
    EventBus.$on("sidebar-mini", (change) => {
      this.isSidebarSmall = change;
      this.currentMenuTab = "Menu";
    });
    this.currentActiveMenu = this.activeMenu.replace(/\//, "");
    // Load menu list on page load
    // this.menuDetail();
  },
};
</script>
